"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchPreviewDialog = void 0;
var _toggleMenuFlyout = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var ToggleMenuFlyout = _toggleMenuFlyout;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _navigation = require("../../../../context/navigation");
var _topAreaBannerContext = require("../../../../context/topAreaBannerContext");
var _hooks = require("../../../../hooks");
var _SearchPreview = require("../../../SearchPreview");
var _SearchPreviewMobile = require("../../../SearchPreview/SearchPreviewMobile");
var _SearchPreviewSkeleton = require("../../../SearchPreviewSkeleton");
var _SearchInput = require("../../SearchInput");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SearchPreviewDialog = ({
  searchInputButtonPosition,
  showOnlyOn
}) => {
  const {
    activeMenu,
    hideSearchResultsTab,
    toggleActiveMenu
  } = (0, _navigation.useActiveMenu)();
  const {
    isLoading,
    manualHide,
    hide,
    blur,
    clearResults,
    setValue
  } = (0, _navigation.useSearchInput)();
  const isActive = activeMenu === ToggleMenuFlyout.MenuTypes.SearchResults;
  const {
    visible: isTopBannerVisible
  } = (0, _topAreaBannerContext.useTopAreaBanner)();
  const isMobile = (0, _hooks.useIsMobile)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const onBackButtonClick = (0, _react.useCallback)(() => {
    setValue('');
    clearResults();
    toggleActiveMenu(_toggleMenuFlyout.MenuTypes.SearchInput);
    blur();
  }, [blur, clearResults, setValue, toggleActiveMenu]);
  const header = (0, _react.useMemo)(() => isMobile ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SearchWithBackButtonContainer, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
      "data-testid": getTestId(_constants.SEARCH_PREVIEW_DIALOG_BACK_BUTTON),
      size: "medium",
      variant: "text",
      onClick: onBackButtonClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowLeftThin, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchInput.SearchInput, {})]
  }) : undefined, [getTestId, isMobile, onBackButtonClick]);
  const closeSearch = (0, _react.useCallback)(() => {
    manualHide();
    hide();
    hideSearchResultsTab();
  }, [hide, hideSearchResultsTab, manualHide]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledSearchPreviewDialog, {
    fullWidth: true,
    hideCloseButton: true,
    "data-testid": getTestId(_constants.SEARCH_PREVIEW_DIALOG),
    showOnlyOn: showOnlyOn,
    position: searchInputButtonPosition,
    open: isActive,
    header: header,
    isTopBannerVisible: isTopBannerVisible,
    maxWidth: "960px",
    onClose: closeSearch,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SearchPreviewRoot, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SearchPreviewContent, {
        children: isMobile ? isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchPreviewSkeleton.SearchPreviewMobileSkeleton, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchPreviewMobile.SearchPreviewMobile, {}) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchInput.SearchInput, {}), isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchPreviewSkeleton.SearchPreviewSkeleton, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchPreview.SearchPreview, {})]
        })
      })
    })
  });
};
exports.SearchPreviewDialog = SearchPreviewDialog;
